import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ResultCard from "@/components/ResultCard";
import ResultCardSkeleton from "@/components/ResultCardSkeleton";
import FAQSection from "@/components/FAQSection";
import StructuredData from "@/components/StructuredData";
import { Button } from "@/components/ui/button";
import { Link } from "@/lib/router-compat";
import { useLotteryResults } from "@/hooks/useLotteryResults";

const NicaHoy = () => {
  const { data: results, isLoading } = useLotteryResults(0);
  const nicaraguaResults = results?.nicaraguaResults || [];

  const faqs = [
    {
      question: "¿Qué salió hoy en Nicaragua?",
      answer: "Los resultados de hoy de la Diaria Loto de Nicaragua están disponibles arriba. De lunes a viernes hay tres sorteos (11am, 3pm y 9pm) y los sábados y domingos se agrega el sorteo de las 6pm."
    },
    {
      question: "¿A qué hora salen los resultados de Nicaragua?",
      answer: "La Diaria Loto de Nicaragua sortea a las 11:00 AM, 3:00 PM y 9:00 PM hora de Nicaragua de lunes a viernes. Los sábados y domingos se suma el sorteo de las 6:00 PM."
    },
    {
      question: "¿Cómo funciona el MultiX?",
      answer: "El MultiX puede ser JG (juego simple), 2X (multiplica por 2), 3X (multiplica por 3) o 5X (multiplica por 5). Si aciertas el número con MultiX, tus ganancias se multiplican."
    },
  ];

  const today = new Date().toLocaleDateString('es-ES', { 
    timeZone: 'America/Costa_Rica',
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  return (
    <>
      <StructuredData
        title="Resultados Diaria Loto Nicaragua Hoy"
        description="Resultados actualizados de la Diaria Loto de Nicaragua - Sorteos de 11am, 3pm y 9pm (con 6pm los fines de semana)"
        results={nicaraguaResults}
        country="nicaragua"
      />
      
      <div className="min-h-screen flex flex-col">
        <Navigation />
        
        <main className="flex-1 container mx-auto px-4 py-8">
          {/* Header */}
          <header className="text-center mb-12">
            <h1 className="text-3xl md:text-5xl font-bold mb-4 text-nicaragua">
              🇳🇮 Tiempos Nica Hoy: resultados de la Loto Diaria de Nicaragua
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground mb-2">
              Resultados de la Diaria Loto
            </p>
            <p className="text-sm text-muted-foreground capitalize">{today}</p>
          </header>

          {/* Navigation Links */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            <Button asChild variant="default">
              <Link to="/tiempos-nica-hoy">Hoy</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/que-salio-ayer-en-la-nica">Ayer</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/nica-antier">Antier</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/">🇨🇷 Ver Costa Rica</Link>
            </Button>
          </div>

          {/* Results */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {isLoading ? (
              <>
                <ResultCardSkeleton country="nicaragua" />
                <ResultCardSkeleton country="nicaragua" />
                <ResultCardSkeleton country="nicaragua" />
                <ResultCardSkeleton country="nicaragua" />
              </>
            ) : nicaraguaResults.length > 0 ? (
              nicaraguaResults.map((result, index) => (
                <ResultCard
                  key={index}
                  country="nicaragua"
                  {...result}
                />
              ))
            ) : (
              <p className="text-center text-muted-foreground col-span-full">No hay resultados disponibles para hoy.</p>
            )}
          </div>

          {/* FAQ */}
          <FAQSection faqs={faqs} />

          {/* SEO Content */}
          <article className="mt-16 max-w-3xl mx-auto prose prose-sm">
            <h2>Tiempos Nica Hoy: ¿qué salió en la Diaria Loto?</h2>
            <p>
              Consulta los resultados más recientes de la Diaria Loto de Nicaragua. 
              Actualizamos los números ganadores inmediatamente después de cada sorteo 
              de las 11am, 3pm y 9pm. Los sábados y domingos también se sortea a las 6pm.
            </p>
            <p>
              Cada resultado incluye el número ganador (00-99), el multiplicador MultiX 
              (JG, 2X, 3X, 5X) y el dígito final (0-9). Revisa si tu número fue el 
              afortunado del día.
            </p>
          </article>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default NicaHoy;
